// extracted by mini-css-extract-plugin
module.exports = {"gallery":"Gallery_gallery__1r2FY","collectionList":"Gallery_collectionList__1w0wc"};